export enum WizardHotelPWAv2Views {
  DEFAULT = "default",
  HOTWIRE = "hotwire",
}
